import { syncPushLocale } from "../hooks/usePushNotifications";

// Moves this device onto the broadcast topic for a language.
//
// The client does NOT subscribe to topics itself. The backend owns all topic
// management through the Admin SDK inside /register-device and
// /unregister-device, so re-registering the same token with a new Locale is
// what shifts the device between `all-users-{env}-en` and `-ar`. A device that
// self-subscribes ends up on a topic with no UserDeviceTokens row: it receives
// broadcasts but no targeted pushes, and nothing lands in its /mine inbox.
//
// This previously posted to the iOS wrapper's `push-subscribe` handler to join
// `lang_en` / `lang_ar`. Those topics are not part of the notifications API and
// nothing sends to them, so that path was dropped rather than left to look
// functional.
//
// Skip calling this after a language switch and the OS tray keeps rendering
// broadcasts in the previous language.
export const setLanguageTopic = (language) => {
  if (!language) return;
  // No token registered, or signed out, is not an error — the next
  // /register-device on launch or login picks up the current language.
  syncPushLocale(language).catch(() => {});
};

export default setLanguageTopic;
